function mapAddressPayload(address) {
  if (!address) return address

  const mappedAddress = { ...address }

  if (Object.prototype.hasOwnProperty.call(mappedAddress, 'postCode')) {
    mappedAddress.post_code = mappedAddress.postCode
    delete mappedAddress.postCode
  }

  return mappedAddress
}

export function mapFacilityPayload(facility) {
  if (!facility) return facility

  const mappedFacility = { ...facility }

  if (Object.prototype.hasOwnProperty.call(mappedFacility, 'providesFreeRentalSkates')) {
    mappedFacility.provides_free_rental_skates = mappedFacility.providesFreeRentalSkates
    delete mappedFacility.providesFreeRentalSkates
  }

  if (Object.prototype.hasOwnProperty.call(mappedFacility, 'isRemovingCard')) {
    mappedFacility.is_removing_card = mappedFacility.isRemovingCard
    delete mappedFacility.isRemovingCard
  }

  if (Object.prototype.hasOwnProperty.call(mappedFacility, 'address')) {
    mappedFacility.address = mapAddressPayload(mappedFacility.address)
  }

  return mappedFacility
}

export function mapKlassPayload(klass) {
  if (!klass) return klass

  const mappedKlass = { ...klass }

  if (Object.prototype.hasOwnProperty.call(mappedKlass, 'maxStudents')) {
    mappedKlass.max_students = mappedKlass.maxStudents
    delete mappedKlass.maxStudents
  }

  if (Object.prototype.hasOwnProperty.call(mappedKlass, 'supportedSkillLevels')) {
    mappedKlass.supported_skill_levels = mappedKlass.supportedSkillLevels
    delete mappedKlass.supportedSkillLevels
  }

  if (Object.prototype.hasOwnProperty.call(mappedKlass, 'klassPackages')) {
    mappedKlass.klass_packages = mappedKlass.klassPackages
    delete mappedKlass.klassPackages
  }

  if (Object.prototype.hasOwnProperty.call(mappedKlass, 'customSkillLevels')) {
    mappedKlass.custom_skill_levels = mappedKlass.customSkillLevels
    delete mappedKlass.customSkillLevels
  }

  if (Object.prototype.hasOwnProperty.call(mappedKlass, 'curriculumId')) {
    mappedKlass.curriculum_id = mappedKlass.curriculumId
    delete mappedKlass.curriculumId
  }

  delete mappedKlass.curriculumMode
  delete mappedKlass.curriculumName

  return mappedKlass
}

export function mapKlassPackagePayload(klassPackage) {
  if (!klassPackage) return klassPackage

  const mappedKlassPackage = { ...klassPackage }

  if (Object.prototype.hasOwnProperty.call(mappedKlassPackage, 'open')) {
    mappedKlassPackage.active = mappedKlassPackage.open
    delete mappedKlassPackage.open
  }

  if (Object.prototype.hasOwnProperty.call(mappedKlassPackage, 'proratedPricing')) {
    mappedKlassPackage.prorated_pricing = mappedKlassPackage.proratedPricing
    delete mappedKlassPackage.proratedPricing
  }

  return mappedKlassPackage
}
